import React from 'react';
import { lookbook } from '../mock/data';

const LifestyleBanner = () => (
  <section className="relative bg-[var(--paper)] border-t border-[var(--line)]">
    <div className="max-frame container-px pt-20 md:pt-28 text-center">
      <p className="reveal text-[11px] uppercase tracking-kicker text-[var(--muted)]">The Halloween collection</p>
      <h2 className="reveal mt-5 font-display uppercase font-tight text-[clamp(2.2rem,5vw,4.2rem)] leading-[0.95]">
        Four colors for the <span className="text-[var(--accent)]">season</span>
      </h2>
    </div>
    <figure className="reveal mt-12 md:mt-16 w-full overflow-hidden bg-[var(--paper)]">
      <img
        src="/products/lifestyle-hero.jpg"
        alt="The four Halloween Lotus totes — Black, Nightshade, Toxic and Violet — styled on stone plinths"
        className="w-full h-auto block"
      />
    </figure>
  </section>
);

export default LifestyleBanner;
